import React, { useEffect } from "react";
import { times } from "lodash";
import { useTheme } from "@mui/material/styles";

import { useMap } from "react-map-gl";

import { comparisonOverlapGradient, extractBreaks, getFillColor } from "@/utils";
import { LocationResult, LocationScore } from "@/types";

type CompareMapOverlayProps = {
  scores: LocationScore[];
  overlap: LocationScore[];
  gradient?: string[];
  firstTime: boolean;
};

export const CompareMapOverlay: React.FC<CompareMapOverlayProps> = ({
  scores,
  overlap,
  gradient,
  firstTime,
}) => {
  const { current: map } = useMap();
  const theme = useTheme();

  useEffect(() => {
    if (!firstTime) {
      map && map.isStyleLoaded() && resetMap();
      map &&
        scores.forEach((value) => {
          map.setFeatureState(
            {
              id: value.gid,
              source: "area-source",
              sourceLayer: "postal_area_test",
            },
            { score: value.rate, name: value.name, level: value.level },
          );
        });
      map &&
        overlap.forEach((value) => {
          map.setFeatureState(
            {
              id: value.gid,
              source: "overlap-source",
              sourceLayer: "postal_area_test",
            },
            { score: value.rate, name: value.name, level: value.level },
          );
        });
      map &&
        map
          .getMap()
          .setPaintProperty(
            "area-base",
            "fill-color",
            getFillColor(extractBreaks(scores), gradient ?? theme.palette.gradient),
          );
      map &&
        map
          .getMap()
          .setPaintProperty(
          "area-overlap",
          "fill-color",
          getFillColor(extractBreaks(overlap), comparisonOverlapGradient)
        );
    }
  }, [firstTime, map, scores, overlap]);

  const resetMap = () => {
    map &&
      [...times(124)].forEach((value) => {
        map.setFeatureState(
          { id: value, source: "area-source", sourceLayer: "postal_area_test" },
          { score: null, name: null, level: null },
        );
      });

    map &&
    [...times(124)].forEach((value) => {
      map.setFeatureState(
        { id: value, source: "overlap-source", sourceLayer: "postal_area_test" },
        { score: null, name: null, level: null },
      );
    });
  };

  return <></>;
};
